import { render, staticRenderFns } from "./MenuItemPeriod.vue?vue&type=template&id=2e721992&scoped=true&"
import script from "./MenuItemPeriod.vue?vue&type=script&lang=js&"
export * from "./MenuItemPeriod.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemPeriod.vue?vue&type=style&index=0&id=2e721992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e721992",
  null
  
)

export default component.exports